import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import HippaIconSection from '@Components/Common/HippaIconSection';
import RetailerStyle from './Retailer.style';
import { LeftRightDesginIcon, LinkAnchor, refferalRouting } from '@Components/Common/CommonMethods';
import { useRouter } from 'next/router';
import ProfessionalRetailerPopup from '@PagesComponent/Professional_RetailerPopup';
import IngredientList from '@Components/Common/IngredientList/IngredientList';

import { useRef } from 'react';

function RetailerPage(props) {
    const router = useRouter();

    const [show, setShow] = useState(false);
    const [loginToken, setLoginToken] = useState(false);

    function handleOpenPopup() {
        document.body.classList.add('professional_retailer_form_popup');
        setShow(true);
    }

    useEffect(() => {
        if (localStorage.getItem('Token')) {
            setLoginToken(true);
        } else {
            setLoginToken(false);
        }
    }, []);

    const ref = useRef();
    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (ref.current && !ref.current.contains(e.target)) {

                setShow(false);
                document.body.classList.remove('professional_retailer_form_popup');
                //   onClose()
            }
        }
        document.addEventListener("click", checkIfClickedOutside)
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [show])

    function RetailerShare() {
        if (loginToken) {
            router?.push("/us/user/become_retailer/")
        }
        else {
            router.push('/us/signup?d=is_retailer/');

        }
    }


    return (
        <RetailerStyle>
            <div className='main_retailer_section' ref={ref}>
                <LeftRightDesginIcon>
                    <div className='title_sections'>
                        <h2>Retailers</h2>
                        <h3>We Custom Compound Nutritional Supplements For Your Customers.</h3>
                    </div>
                    <div className='text_container'>
                        <div className='container'>
                            <div className='d-flex row'>
                                <div className='col-md-6'>
                                    <div className='first_content_section'>
                                        <p>
                                            Health-savvy consumers are over one-size-fits-all
                                            solutions. They want personalized health and wellness
                                            tools that are simple to implement and affordable to boot.
                                        </p>
                                        <div className='image_text_one'>
                                            <div className='image'>
                                                <img src="/images/code_comple.png" loading='lazy' alt='complex' />
                                            </div>
                                            <div className='content'>
                                                <p>
                                                    We check all the boxes (and more)
                                                    with our proprietary, DNA-based
                                                    customized nutrition. While nearly
                                                    400 million nutritional combinations
                                                    are possible, only one is formulated
                                                    per individual, and contains the
                                                    precise nutrients, in the exact amounts
                                                    recommended, based on each
                                                    customer’s unique genetic imprint.
                                                </p>
                                            </div>
                                        </div>
                                        <div className='text_two'>
                                            <p>
                                                Our personalized supplements take the guesswork out of
                                                foundational nutrition and are delivered right to your
                                                customers’ doors on auto-ship, making sustained,
                                                recurring orders the easy choice.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='second_content_section'>
                                        <div className='message_tip'>
                                            <div className='image'>
                                                <img src="/images/bg-purple.png" />
                                            </div>
                                            <div className='content-quote'>
                                                <p>
                                                    "When identifying ways to stand out, customization
                                                    is key. It has boundless potential for both brands and
                                                    customers...Custom products are the future of small
                                                    and medium-sized businesses.”
                                                </p>
                                                <div>
                                                    <LinkAnchor className="elementor-testimonial-name" href="https://www.forbes.com/sites/forbestechcouncil/2021/02/25/the-future-of-smb-retail-custom-and-personalized-products/?sh=24441a5a6727" target="_blank">
                                                        forbes
                                                    </LinkAnchor>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='button_sections'>
                            <LinkAnchor href={refferalRouting('/us/retailers/retailer_form/')}>
                                <button className='learn_more'>LEARN MORE</button>
                            </LinkAnchor>

                            <button className='join_as_button' onClick={() => RetailerShare()}>{!loginToken ? "JOIN AS A RETAILER NOW" : "BECOME A RETAILER"}</button>
                        </div>
                        <IngredientList />
                    </div>
                    {show && <ProfessionalRetailerPopup open={show} setOpen={setShow} section="retailer" plan="Retailer plan" />}
                    <HippaIconSection />
                </LeftRightDesginIcon >
            </div>

        </RetailerStyle >
    )
}

RetailerPage.propTypes = {}

export default RetailerPage;
